/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

export default {
    /**
     * Takes a <form> element and serializes it into an object where the keys are the element
     * names and the values are their values.
     *
     * The resulting object can be used with the utils/url module to create a query string or a
     * full url. For the former pass the object returned from this function to `toQueryString`
     * and for the latter use the object returned from this function as the `searchParams` property
     * of the object passed to `unparse`.
     *
     * @param {HTMLFormElement} form
     * @returns {object}
     */
    serialize: function(form) {
        var result = {};
        var element;

        if (!form || form.nodeName !== "FORM") {
            return result;
        }

        function addValue(key, value) {
            if (Array.isArray(result[key])) {
                result[key].push(value);
            } else if (result.hasOwnProperty(key)) {
                result[key] = [result[key], value];
            } else {
                result[key] = value;
            }
        }

        function serializeMultiSelectInputs(element) {
            for (let j = 0; j < element.options.length; j++) {
                if (element.options[j].selected) {
                    addValue(element.name, element.options[j].value);
                }
            }
        }

        for (let i = 0; i < form.elements.length; i++) {
            element = form.elements[i];

            // ignore any element without a name
            if (!element.name) {
                continue;
            }

            // ignore file inputs as if XHR file upload is needed then FormData would be the thing to use
            if (element.type === "file") {
                continue;
            }

            // ignore checkbox and radio inputs that are not checked
            if (["checkbox", "radio"].indexOf(element.type) !== -1 && !element.checked) {
                continue;
            }

            // special case for multi-select select inputs
            if (element.tagName === "SELECT" && element.type === "select-multiple") {
                serializeMultiSelectInputs(element);
                continue;
            }

            // now we now it must be an input, textarea, single select, checked radio/checkbox etc...
            addValue(element.name, element.value);
        }

        return result;
    },

    /**
     * Set the caret to the end of the input field
     *
     * @method setCaretToEnd
     * @param {element} element input or textarea
     */
    setCaretToEnd: function(element) {
        if (element.setSelectionRange) {
            var pos = element.value.length;
            element.setSelectionRange(pos, pos);
        } else if (element.createTextRange) {
            var range = element.createTextRange();
            range.collapse(false);
            range.select();
        }
    },

    /**
     * Select all text
     *
     * @method selectAll
     * @param {element} element input or textarea
     */
    selectAll: function(element) {
        if (element.setSelectionRange) {
            element.focus();
            element.setSelectionRange(0, element.value.length);
        } else if (element.createTextRange) {
            var range = element.createTextRange();
            range.collapse(true);
            range.moveEnd("character", 0);
            range.moveStart("character", element.value.length);
            range.select();
        }
    }
};

